import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8vbjw4gshg: FaireBrandEntity = {
  token: "b_8vbjw4gshg",
  type: "brand",
  name: "Abigail Jayne Design",
  avatarUrl:
    "https://cdn.faire.com/fastly/49a4b4b8ebd9a41fd0b7091cc728b3739869b933c6dd330480bab4aee1da1a74.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/986688354612b1157673969968033f148facf28aae682c745ad7ec0b4e755a4f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/49a4b4b8ebd9a41fd0b7091cc728b3739869b933c6dd330480bab4aee1da1a74.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/986688354612b1157673969968033f148facf28aae682c745ad7ec0b4e755a4f.jpeg",
  location: "Venice, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 272,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a stationery and design studio founded in Venice, California in 2017.  We create high end stationery, matches, notebooks, and paper products designed to encourage connection and love.  Our unique painting style, gold foil accents, and classic messaging is what sets our line apart. \n\nOur artwork is inspired by the world around us, and as we travel, learn, and evolve our line continues to expand to include new imagery and products. \nWe pride ourselves on our versatility and love that every store can curate a unique collection that speaks to their customer.\n\nWe believe in keeping snail mail alive and that a beautiful card is always enough!\n\nIf you prefer your greeting cards to ship without sleeves please let us know when you place your order. \nWe try our best to care for the environment so we ship orders with recycled packaging. \n\nAll orders ship from our studio in Los Angeles, CA.\n    ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:56.744Z",
    importedBy: "entity-db-cli",
  },
};
